// router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store';
const routes = [
    {
        path: '/',
        name: 'UserLogin',
        component: () => import('../components/user/UserLoginPage.vue'),
        meta:{
          title:"UserLogin"
        }
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('../components/MyHome.vue'),
      meta:{
        requiresAuth: true
      },
      children: [
        {
          path:"apps/manage",
          name: "AppManagement",
          meta:{
            title: "AppsManagement",
            requiresAuth: true
          },
          component: () => import('../components/apps/AppManagementPage.vue')
        },
        {
          path: 'total',  // 子路由路径是相对的，不需要加 /home
          name: 'total',
          meta: {
            title: 'Total',
            requiresAuth: true
          },
          component: () => import('../components/statistics/TotalPage.vue')
        },
        {
          path: 'user',  // 子路由路径是相对的，不需要加 /home
          name: 'UserInfo',
          meta: {
            title: 'UserInfo',
            requiresAuth: true
          },
          component: () => import('../components/user/UserInfoPage.vue')
        },
        {
          path: 'apps',  // 子路由路径是相对的
          name: 'MyAppsPage',
          meta: {
            title: 'MyApps',
            requiresAuth: true
          },
          component: () => import('../components/apps/MyAppsPage.vue')
        },
        {
          path: 'appUserData',  // 子路由路径是相对的
          name: 'AppUserDataPage',
          meta: {
            title: 'AppUserData',
            requiresAuth: true
          },
          component: () => import('../components/analyze/AppUserDataPage.vue')
        },
        {
          path: 'settings',
          name: 'SettingsPage',
          meta: {
            title: 'Settings',
            requiresAuth: true
          },
          component: () => import('../components/settings/SettingsPage.vue')
        },
        {
          path: 'user/manage',
          name: 'UserManagement',
          meta: {
            title: 'UserManagement',
            requiresAuth: true
          },
          component: () => import('../components/user/UserManagementPage.vue')
        },
        {
          path: 'log',
          name: 'SystemLog',
          meta: {
            title: 'SystemLog',
            requiresAuth: true
          },
          component: () => import('../components/log/SystemLogPage.vue')
        },
        {
          path: 'feedback',
          name: 'feedback',
          meta: {
            title: 'feedback',
            requiresAuth: true
          },
          component: () => import('../components/feedback/FeedBackPage.vue')
        }
      ]
    }
]

const router = createRouter({
  history: createWebHistory(), // 使用 HTML5 History 模式
  routes // 配置路由
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.isUserLoggedIn;

  // 如果要访问的页面需要登录，且用户未登录，跳转到登录页面
  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'UserLogin' });
  } else {
    next(); // 继续路由导航
  }
});

export default router